export default "__VITE_ASSET__BKD35lES__"